import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgMediaSoundOn24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Sound On",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.505 5.858a.75.75 0 1 0-1.086 1.035A7.37 7.37 0 0 1 20.465 12a7.37 7.37 0 0 1-2.046 5.108.751.751 0 0 0 1.085 1.035 8.86 8.86 0 0 0 2.46-6.142c0-2.3-.873-4.481-2.46-6.144"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.22 12.001c0-.969-.27-1.925-.785-2.766a.75.75 0 0 0-1.28.783c.37.604.566 1.29.566 1.982s-.195 1.378-.566 1.982a.75.75 0 1 0 1.28.783 5.3 5.3 0 0 0 .786-2.764M14.22 8.781v-6.03a.749.749 0 0 0-1.215-.59l-6.61 5.194h-2.15c-1.219 0-2.21.992-2.21 2.21v4.868c0 1.22.991 2.21 2.21 2.21h2.002a.7.7 0 0 0 .29.113l6.469 5.083a.75.75 0 0 0 .791.085.75.75 0 0 0 .422-.674v-6.03A3.35 3.35 0 0 0 16.68 12a3.35 3.35 0 0 0-2.46-3.219M3.534 14.434V9.566a.71.71 0 0 1 .71-.71h1.658v6.29H4.245a.71.71 0 0 1-.71-.712m9.185 5.273L7.403 15.53V8.47l5.316-4.177v15.414m1.5-6.099v-3.216c.571.316.96.917.96 1.608a1.84 1.84 0 0 1-.96 1.608"
}));

export { SvgMediaSoundOn24 as default };
//# sourceMappingURL=MediaSoundOn24.js.map
